import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { hubIndexHead } from "@/lib/hub-seo";

const PATH = "/cafes";

export const Route = createFileRoute("/cafes/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("cafes")),
  head: ({ loaderData }) =>
    hubIndexHead({
      path: PATH,
      locale: "en",
      loaderData,
      fallbackTitle: 'Cafés in Finland — coffee and bakeries | what Finland',
      fallbackDescription: 'Finnish cafés and bakeries by region and price range, with opening hours and menus.',
      listName: 'Cafés in Finland',
    }),
  component: () => <HubIndexPage slug="cafes" locale="en" />,
});
